module.exports = __webpack_public_path__ + "img/zhhb.e7037437.png";